import { AuthContextProvider, NotificationProvider, WalletContextProvider, CartProvider } from 'src/contexts';
import AppRouter from './routes/AppRouter';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ViewportProvider } from './context/ViewportContext';

export default function App() {
  return (
    <ViewportProvider>
      <AuthContextProvider>
        <NotificationProvider>
          <WalletContextProvider>
            <CartProvider>
              <ToastContainer />
              <AppRouter />
            </CartProvider>
          </WalletContextProvider>
        </NotificationProvider>
      </AuthContextProvider>
    </ViewportProvider>
  );
}
